/*
 * Copyright (c) 2018 Helvia Technologies PC <contact@helvia.io>
 */

import Icon from '@ant-design/icons';

const WebchatUserSvg = () => (
  <svg
    id="Capa_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    width={'100%'}
    height={'7.5em'}
    viewBox="0 0 302 302"
    style={{ enableBackground: 'new 0 0 302 302' }}
    xmlSpace="preserve"
  >
    <style type="text/css">
      {'\n        .user-icon-0{fill:#E6EBEE;}\n        .user-icon-1{fill:#FFFFFF;}\n    '}
    </style>
    <circle className="user-icon-0" cx={151} cy={151} r={151} />
    <g>
      <path
        className="user-icon-1"
        d="M151,207c-42.3,0-78.7,25.2-95,61.4c25.9,21,59,33.6,95,33.6s69-12.6,95-33.6C229.7,232.2,193.3,207,151,207z"
      />
    </g>
    <circle className="user-icon-1" cx={149.7} cy={119.8} r={72.3} />
  </svg>
);

export const WebchatUserIcon = (props) => (
  <Icon component={WebchatUserSvg} {...props} />
);
